// Sample activity data with locations from LA and surrounding areas
export const generateActivityItem = () => {
  const locations = [
    // San Fernando Valley
    'Woodland Hills', 'Calabasas', 'Tarzana', 'Sherman Oaks', 'Studio City', 'Encino',
    'Agoura Hills', 'Hidden Hills', 'West Hills', 'Warner Center', 'Canoga Park',
    'North Hollywood', 'Van Nuys', 'Reseda', 'Winnetka',
    
    // Calabasas Areas
    'Calabasas Park Estates', 'The Oaks', 'Mountain Park', 'Cold Creek',
    'Monte Nido', 'The Colony at Calabasas', 'Mulholland Heights',
    
    // Coastal/Westside
    'Malibu', 'Santa Monica', 'Venice', 'Manhattan Beach', 'Pacific Palisades',
    'Beverly Hills', 'West Hollywood', 'Culver City', 'Brentwood',
    
    // Silver Lake & Surroundings
    'Silver Lake', 'Los Feliz', 'Echo Park', 'Atwater Village', 'East Hollywood',
    
    // Other Areas
    'Thousand Oaks', 'Simi Valley', 'Moorpark', 'Santa Clarita', 'Burbank'
  ];

  const activities = [
    {
      type: 'booking',
      icon: '🏠',
      template: 'New showing scheduled in LOCATION',
    },
    {
      type: 'completion',
      icon: '✅',
      template: 'Successful showing completed in LOCATION',
    },
    {
      type: 'agent',
      icon: '👤',
      template: 'New agent joined from LOCATION',
    },
    {
      type: 'listing',
      icon: '🏡',
      template: 'New property listed in LOCATION',
    },
    {
      type: 'offer',
      icon: '📝',
      template: 'Offer submitted for property in LOCATION',
    },
    {
      type: 'feedback',
      icon: '⭐',
      template: 'Positive showing feedback received in LOCATION',
    },
    {
      type: 'tenant',
      icon: '📨',
      template: 'Tenant notice delivered in LOCATION',
    }
  ];

  const activity = activities[Math.floor(Math.random() * activities.length)];
  const location = locations[Math.floor(Math.random() * locations.length)];
  const text = activity.template.replace('LOCATION', location);

  return {
    id: Date.now(),
    type: activity.type,
    text,
    time: 'Just now',
    icon: activity.icon,
    location
  };
};

export const getInitialActivities = () => {
  const activities = [];
  for (let i = 0; i < 10; i++) {
    const activity = generateActivityItem();
    activity.time = getRandomPastTime();
    activities.push(activity);
  }
  return activities.sort((a, b) => b.id - a.id);
};

function getRandomPastTime() {
  const times = [
    'Just now',
    '1 minute ago',
    '2 minutes ago',
    '5 minutes ago',
    '10 minutes ago',
    '15 minutes ago',
    '20 minutes ago',
    '30 minutes ago',
    '1 hour ago',
    '2 hours ago'
  ];
  return times[Math.floor(Math.random() * times.length)];
}